module.exports = __webpack_public_path__ + "img/ic_dic_music3.0794feff.png";